import React from 'react';
import Icon from '@/v2/components/atoms/Icon';

import './Info.scss';

const Info = (props) => (
    <Icon iconName="Info" {...props}>
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32">
            <path d="M16 32H0V16C0 7.2 7.2 0 16 0s16 7.2 16 16-7.2 16-16 16zM2 30h14c7.7 0 14-6.3 14-14S23.7 2 16 2 2 8.3 2 16v14z" />
            <path d="M16.9 15.5l2.6-.4V17l-2.6-.4 1.7 2.1-1.7.9-.9-2.5-1 2.5-1.6-.9 1.7-2.1-2.6.4v-2l2.7.4-1.7-2.1 1.7-1 1 2.5.9-2.5 1.7 1-1.9 2.2z" />
        </svg>
    </Icon>
);

export default Info;
